import { debounce, delay } from 'lodash';

/**
 * 根据页面空间，让超高的表格定高，从而表头吸顶
 * @example <el-table v-table-head-fix :height="tableFixHeight" ...></el-table>
 * @description 所在 Vue 实例的 data 里最好放一个 tableFixHeight: null，否则会 warn
 */
export default {
  inserted (el, binding, vnode) { // eslint-disable-line
    const ctn = document.querySelector('.jc-page-content');
    if (!ctn) throw new Error('.el-table element should be placed in a .jc-page-content element');
    
    function calc() {
      const vm = vnode.context;
      let inn = ctn.querySelector('.jc-content-list');
      let hdr = ctn.querySelector('.el-table__header-wrapper');
      let bdy = ctn.querySelector('.el-table__body-wrapper');
      
      let fixedTbl = ctn.querySelector('.el-table__fixed');
      if (fixedTbl) { // 首列固定等情况
        fixedTbl.style.height = `${
          fixedTbl.querySelector('thead').offsetHeight 
          + bdy.offsetHeight 
        }px`;
      }

      ctn.querySelector('.el-table').style.height = 'unset';
      bdy.style.height = 'unset';

      const originH = inn
        ? Math.max(ctn.scrollHeight, inn.getBoundingClientRect().height)
        : ctn.scrollHeight;

      const innHt = window.innerHeight;
      const ctnRect = ctn.getBoundingClientRect();
      const diff = innHt - ctnRect.top - originH;
      
      if (diff >= 0) return;

      const elRect = el.getBoundingClientRect();
      const h = elRect.height + diff;
      vm.tableFixHeight = `${h}px`;
      bdy.style.height = `${h - hdr.getBoundingClientRect().height}px`;

      console.log('fix table height', h);

      inn = null;
      bdy = null;
      hdr = null;
      fixedTbl = null;
    } // end of calc
    window._calcTableHeight = debounce(calc, 1000);

    window.addEventListener('resize', window._calcTableHeight);
    delay(calc, 1000);
    delay(calc, 6180);
  },
  unbind() {
    window.removeEventListener('resize', window._calcTableHeight);
    delete window._calcTableHeight;

    console.log('unbind fix-head-fix directive');
  }
};



// WEBPACK FOOTER //
// ./src/directives/tableHeadFix.js